import { render, staticRenderFns } from "./Publicacion.vue?vue&type=template&id=6c27c524&scoped=true"
import script from "./Publicacion.vue?vue&type=script&lang=ts"
export * from "./Publicacion.vue?vue&type=script&lang=ts"
import style1 from "./Publicacion.vue?vue&type=style&index=1&id=6c27c524&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c27c524",
  null
  
)

export default component.exports